import React from "react";

/**
 * If we're inside an iframe we send our own height when it changes to our parent
 * so that it can resize the iframe element and avoid ugly scrollbars or hidden content.
 */
const useForwardIframeHeight = (widgetUUID = null) => {
  // Auto resize the widget according to the height of the widget
  const lastHeight = React.useRef(0);

  // Auto resize the widget according to the height of the widget
  React.useEffect(
    () => {
      const timerRef = setInterval(
        () => {
          const height = Math.min(
            document.getElementById("widget-container")?.offsetHeight,
            document.getElementById("widget-container")?.scrollHeight,
          );
          if (height === lastHeight.current) {
            return;
          }
          lastHeight.current = height;
          // notify parent of size change
          window.parent.postMessage(
            {
              origin: "gadget",
              action: "update-size",
              height,
              widgetUUID,
            },
            "*",
          );
        },
        1200,
      );
      return () => clearInterval(timerRef);
    },
    [widgetUUID],
  );
};

export default useForwardIframeHeight;
